import _ from 'lodash';

export function location(ann, imageToDisplayFactor) {
  // annotations are stored with an array of image coordinates, but
  // it is easiest to draw them with top,left,width,height values in display coords.
  if (ann.type === 'point') {
    const { x, y } = ann.coords[0];
    return {
      left: x * imageToDisplayFactor,
      top: y * imageToDisplayFactor,
    };
  } else if (ann.type === 'rect') {
    const
      xs = _.map(ann.coords, 'x'),
      ys = _.map(ann.coords, 'y'),
      top = _.min(ys) * imageToDisplayFactor,
      left = _.min(xs) * imageToDisplayFactor,
      width = (_.max(xs) * imageToDisplayFactor) - left,
      height = (_.max(ys) * imageToDisplayFactor) - top;
    return {
      left,
      top,
      width,
      height,
    };
  } else if (ann.type === 'draw') {
    return ann.coords.map(point => point.map(coord => {
      return {
        x: coord.x * imageToDisplayFactor,
        y: coord.y * imageToDisplayFactor,
      };
    }));
  } else if (ann.type === 'measure') {
    const
      top = ann.coords[0].y * imageToDisplayFactor,
      left = ann.coords[0].x * imageToDisplayFactor,
      width = (ann.coords[1].x * imageToDisplayFactor) - left,
      height = (ann.coords[1].y * imageToDisplayFactor) - top;
    return {
      left,
      top,
      width,
      height,
    };
  }
  return {};
}

export function coordinates(ann, annotationType, displayToImageFactor) {
  const lst = [];
  // this is gross :(
  /*eslint-disable */
  if (annotationType === 'draw') {
    for (let index in ann) {
      lst[index] = [];
      if (ann[index].length) lst[index].push(...ann[index]);
      else {
        for (let key in ann[index]) {
          lst[index].push(ann[index][key]);
        }
      }
    }
    // TRIPLE MAP BRO
    return lst.map(coords => coords.map(coord => _.mapValues(coord, v => v * displayToImageFactor)));
    /* eslint-enable */
  } else if (annotationType === 'measure') {
    lst.push(
      { x: ann.left, y: ann.top },
      { x: ann.left + ann.width, y: ann.top + ann.height },
    );
  } else if (annotationType === 'point') {
    lst.push({ x: ann.left, y: ann.top });
  } else if (_.isNumber(ann.width) && _.isNumber(ann.height)) {
    lst.push(
      { x: ann.left, y: ann.top },
      { x: ann.left + ann.width, y: ann.top },
      { x: ann.left + ann.width, y: ann.top + ann.height },
      { x: ann.left, y: ann.top + ann.height },
    );
  }
  return lst.map(pt => _.mapValues(pt, v => v * displayToImageFactor));
}

export function vertices(coords, displayToImageFactor) {
  return coords.map(coord => _.mapValues(coord, v => v * displayToImageFactor));
}

export function trunc(val, min, max) {
  return Math.max(Math.min(val, max), min);
}

export function renderHighlights(highlights, offset) {
  const canvas = document.querySelector('#filter');
  const ctx = canvas.getContext('2d');
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.fillStyle = 'rgba(0, 0, 0, 0.4)';
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.fill();

  highlights.forEach(highlight => {
    ctx.clearRect(
      highlight.coords[0].x / offset,
      highlight.coords[0].y / offset,
      (highlight.coords[1].x - highlight.coords[0].x) / offset,
      (highlight.coords[3].y - highlight.coords[0].y) / offset,
    );
  });
}

export function draw(coords) {
  const lines = [];
  /* eslint-disable */
  for (let coord in coords) {
    for (let point in coords[coord]) {
      let nextPoint = coords[coord][parseInt(point) + 1];
      if (nextPoint) {
        lines.push({
          x1: coords[coord][point].x,
          y1: coords[coord][point].y,
          x2: nextPoint.x,
          y2: nextPoint.y,
        });
      }
    };
  }
  /* eslint-enable */
  return lines;
}

export function midpoint(point1, point2) {
  return (point1 + point2) / 2;
}

export function slope(loc) {
  return (loc.height) / (loc.width);
}

export function lengthOfLine(coords) {
  /* eslint-disable */
  return Math.ceil(
    Math.sqrt(
      Math.pow((coords[1].x - coords[0].x), 2) +
      Math.pow((coords[1].y - coords[0].y), 2)
    )
  );
  /* eslint-enable */
}

export function pointsAreTooClose(start, stop) {
  return lengthOfLine([start, stop]) < 10;
}



//////////////////
// WEBPACK FOOTER
// ../shared/annotations.js
// module id = null
// module chunks = 